var React = require('react');

function OnDemande (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"3","width":"18","height":"14","rx":"1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"6","y1":"21","x2":"18","y2":"21","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M9 13.1384V6.86159C9 6.47768 9.41474 6.23699 9.74807 6.42747L15.2403 9.56588C15.5762 9.75783 15.5762 10.2422 15.2403 10.4341L9.74807 13.5725C9.41474 13.763 9 13.5223 9 13.1384Z","fill":"currentColor","key":2})]);
}

OnDemande.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = OnDemande;

OnDemande.default = OnDemande;
